import api  from './api';

class MemberService{

    createMember(member){
        return api.post('members/register', JSON.stringify(member));
    }
}
export default new MemberService();
